import PropTypes from 'prop-types';

const displayName = 'Admin';
const propTypes = {};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
